import * as pc from 'playcanvas';

export const setupGrid = (app, size = 20, divisions = 20, color = new pc.Color(0.5, 0.5, 0.5)) => {
    // Create grid entity
    const gridEntity = new pc.Entity('grid');
    
    // Create grid material
    const material = new pc.StandardMaterial();
    material.diffuse = color;
    material.opacity = 0.3;
    material.blendType = pc.BLEND_NORMAL;
    material.depthWrite = false;
    material.emissive = color;
    material.update();

    // Create lines for the grid
    const positions = [];
    const halfSize = size / 2;
    const step = size / divisions;

    // Create horizontal lines
    for (let i = 0; i <= divisions; i++) {
        const x = -halfSize + (i * step);
        positions.push(x, 0, -halfSize, x, 0, halfSize);
    }

    // Create vertical lines
    for (let i = 0; i <= divisions; i++) {
        const z = -halfSize + (i * step);
        positions.push(-halfSize, 0, z, halfSize, 0, z);
    }

    // Create mesh
    const mesh = new pc.Mesh(app.graphicsDevice);
    mesh.setPositions(positions);
    mesh.update(pc.PRIMITIVE_LINES);

    // Add render component
    gridEntity.addComponent('render', {
        material: material,
        meshInstances: [new pc.MeshInstance(mesh, material)]
    });

    // Add axes
    const axesEntity = createAxes(app, size);
    gridEntity.addChild(axesEntity);

    return gridEntity;
};

const createAxes = (app, size) => {
    const axesEntity = new pc.Entity('axes');
    
    // Create materials for each axis with increased visibility
    const xMaterial = new pc.StandardMaterial();
    xMaterial.diffuse = new pc.Color(1, 0, 0);
    xMaterial.emissive = new pc.Color(1, 0, 0);
    xMaterial.opacity = 1;
    xMaterial.update();

    const yMaterial = new pc.StandardMaterial();
    yMaterial.diffuse = new pc.Color(0, 1, 0);
    yMaterial.emissive = new pc.Color(0, 1, 0);
    yMaterial.opacity = 1;
    yMaterial.update();

    const zMaterial = new pc.StandardMaterial();
    zMaterial.diffuse = new pc.Color(0, 0, 1);
    zMaterial.emissive = new pc.Color(0, 0, 1);
    zMaterial.opacity = 1;
    zMaterial.update();

    // Create axis lines
    const positions = [
        0, 0, 0, size, 0, 0,  // X axis
        0, 0, 0, 0, size, 0,  // Y axis
        0, 0, 0, 0, 0, size   // Z axis
    ];

    const mesh = new pc.Mesh(app.graphicsDevice);
    mesh.setPositions(positions);
    mesh.update(pc.PRIMITIVE_LINES);

    // Create mesh instances for each axis
    const xAxisMesh = new pc.MeshInstance(mesh, xMaterial);
    const yAxisMesh = new pc.MeshInstance(mesh, yMaterial);
    const zAxisMesh = new pc.MeshInstance(mesh, zMaterial);

    axesEntity.addComponent('render', {
        material: xMaterial,
        meshInstances: [xAxisMesh, yAxisMesh, zAxisMesh]
    });

    return axesEntity;
};